import type { Token } from '@/types/token';
import { callApi } from '@/utils/api';
import { handleAxiosError } from '@/utils/error';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTokenStore = defineStore('token', () => {
    const token = ref<Token>({} as Token);

    async function fetchByJwtToken(jwtToken: string): Promise<Token> {
        try {
            const result = await callApi({
                method: 'GET',
                endpoint: `tokens/${jwtToken}`,
                jwtTokenRequired: false
            });

            token.value = result.object as Token;
            return token.value;
        } catch (error) {
            return handleAxiosError(error, [], 'Token kon niet opgehaald worden');
        }
    }

    return {
        fetchByJwtToken
    };
});
